import GuestProps from '@interfaces/guest/GuestProps';
import ProfileVO from '@interfaces/profiles/ProfileVO';
import ProfileContentVO from '@interfaces/contents/ProfileContentVO';
import { PackageRequestVO } from '@interfaces/contents/QuestionnaireVO';

export enum SearchAnalyticUserType {
  VIEWER = 'VIEWER',
  SHARER = 'SHARER'
}

export enum SearchResultSource {
  VIEW_RESULTS = 'VIEW_RESULTS',
  ENTER_KEY = 'ENTER_KEY',
  RECENT_SEARCH = 'RECENT_SEARCH',
  FILTERS = 'FILTERS',
  RECOMMENDATION = 'RECOMMENDATION'
}

export enum SearchResultTrackAction {
  OPENED = 'OPENED',
  DOWNLOADED = 'DOWNLOADED',
  BREAD_CRUMB_CLICKED = 'BREAD_CRUMB_CLICKED'
}

export enum ProfileEntityType {
  PROFILE = 'PROFILE',
  PROFILE_SECTION = 'PROFILE_SECTION',
  DESCRIPTION = 'DESCRIPTION',
  PQ = 'PQ',
  PQ_SECTION = 'PQ_SECTION',
  PQ_QA = 'PQ_QA',
  PQ_ATTACHMENT = 'PQ_ATTACHMENT',
  PD = 'PD',
  PROFILE_FAQ = 'PROFILE_FAQ'
}

export enum QuestionType {
  QUESTION = 'QUESTION',
  DESCRIPTION = 'DESCRIPTION'
}

interface AnswerVO {}


export interface AttachedEntityVO {
  sectionId: string;

  sectionName: string;

  questionId: string;

  question: string;
}


export interface SearchAnalyticResultVO {
  id: string;
  name: string;
  type: ProfileEntityType;
  actions: SearchResultTrackAction[];
  lastAccessedTs: string;
}



export interface SearchAnalyticVO {
  id: string;
  companyId: string;
  profileId: string;
  profileType: string;
  performedBy: string;
  performedTs: string;
  userType: SearchAnalyticUserType;
  keyword: string;
  highlightedWords: string[];
  filters: Record<string, unknown>;
  resultSource: SearchResultSource;
  resultCount: number;
  utilizedResults: SearchAnalyticResultVO[];
}

export interface SearchResponseVO {
  id: string;
  companyId: string;
  name: string;
  nameMatch: string;
  description: string;
  descriptionMatch: string;
  contentMatch: string;

  answers: AnswerVO[];

  answerMatch: string[];
  profileId: string;
  profileName: string;
  profileDetails: ProfileVO;

  questionnaireId: string;

  questionnaireName: string;

  sectionId: string;
  sectionName: string;
  questionType: QuestionType;
  fileId: string;
  fileName: string;
  fileType: string;
  fileTypeName: string;
  fileSize: number;
  uploadBy: string;
  downloadAuthKey: string;
  entityType: ProfileEntityType;

  createdDate: string;

  createdBy: string;

  updatedDate: string;

  updatedBy: string;

  usedProfiles: ProfileContentVO[];

  attachedEntity: AttachedEntityVO[];

  builderType?: string;
}

export interface SearchResponseVOList {
  results: SearchResponseVO[];

  nextCursorMark: string;

  totalRecords: number;

  highlightWords: string[];

  packages: { [key: string]: PackageRequestVO[] };

  analyticVO: SearchAnalyticVO;
}

export interface SearchRequestVO {
  term: string;
  searchIn: string;
  entityTypes: string[];
  profileId: string;
  limit: number;
  cursor: string | null;
  ids: string[];
  source: SearchResultSource;
}


export interface ResultRendererProps {
  result: SearchResponseVO;
  trackEvent: (action: SearchResultTrackAction) => void;
}

export interface TrackSearchEventProps {
  guestProps: Partial<GuestProps>;
  profileVO: Partial<ProfileVO>;
  searchQuery?: SearchRequestVO;
  resultSource?: SearchResultSource;
  searchResponse?: SearchResponseVOList;
  action: SearchResultTrackAction;
  utilizedResult: SearchResponseVO;
}


export interface RecentSearchVO {
  searchedDate?: string;
  query: SearchRequestVO;
}
